<template>
  <div class="">
    <div class="d-flex justify-content-between">
      <div class="header-logo">
        <a href="https://cycleai.net/">
          <img :src="image" />
        </a>
      </div>

      <div class="menu-btn-group" v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm">
        <v-btn dark icon @click="openMenu">
          <v-icon>menu</v-icon>
        </v-btn>
        <div class="responsive-menu" v-show="open">
          <div class="our-product-menu">
          <v-menu 
            content-class="navbar-menu"
            attach="term-container"
            offset-y
            location="top center"
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on">
                <span>Our Products</span>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="select-down-arrow"
                >
                  <g clip-path="url(#clip0_1224_2961)">
                    <path
                      d="M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z"
                      fill="#373737"
                    ></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_1224_2961">
                      <rect width="24" height="24" fill="white"></rect>
                    </clipPath>
                  </defs>
                </svg>
              </v-btn>
            </template>

            <v-list>
              <v-list-tile v-for="(item, index) in products" :key="index" :href=item.href >
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
        <div class="our-product-menu">
          <v-menu
            content-class="navbar-menu"
            attach="term-container"
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on">
                <span>Our Crowdsources</span>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="select-down-arrow"
                >
                  <g clip-path="url(#clip0_1224_2961)">
                    <path
                      d="M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z"
                      fill="#373737"
                    ></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_1224_2961">
                      <rect width="24" height="24" fill="white"></rect>
                    </clipPath>
                  </defs>
                </svg>
              </v-btn>
            </template>

            <v-list>
              <v-list-tile v-for="(item, index) in crowdsources" :key="index" :href=item.href>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
        <div class="our-product-menu">
          <v-menu
            content-class="navbar-menu"
            attach="term-container"
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on">
                <span>About Us</span>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="select-down-arrow"
                >
                  <g clip-path="url(#clip0_1224_2961)">
                    <path
                      d="M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z"
                      fill="#373737"
                    ></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_1224_2961">
                      <rect width="24" height="24" fill="white"></rect>
                    </clipPath>
                  </defs>
                </svg>
              </v-btn>
            </template>

            <v-list>
              <v-list-tile v-for="(item, index) in about" :key="index" :href=item.href>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
        <div class="our-product-menu" v-if="activeUser">
          <v-menu open-on-hover 
            content-class="navbar-menu"
            attach="term-container"
            offset-y
            location="top center"
          >
          <template v-slot:activator="{ on }">
              <v-btn v-on="on">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>
              </v-btn>
            </template>

            <v-list>
              <v-list-tile @click="logout()">
                <v-list-tile-title>Logout</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
        </div>
      </div>
      <div class="d-flex align-items-center menu-btn-group" v-else>
        <div class="our-product-menu">
          <v-menu open-on-hover 
            content-class="navbar-menu"
            attach="term-container"
            offset-y
            location="top center"
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on">
                <span>Our Products</span>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="select-down-arrow"
                >
                  <g clip-path="url(#clip0_1224_2961)">
                    <path
                      d="M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z"
                      fill="#373737"
                    ></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_1224_2961">
                      <rect width="24" height="24" fill="white"></rect>
                    </clipPath>
                  </defs>
                </svg>
              </v-btn>
            </template>

            <v-list>
              <v-list-tile v-for="(item, index) in products" :key="index" :href=item.href >
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
        <div class="our-product-menu">
          <v-menu
            open-on-hover
            content-class="navbar-menu"
            attach="term-container"
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on">
                <span>Our Crowdsources</span>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="select-down-arrow"
                >
                  <g clip-path="url(#clip0_1224_2961)">
                    <path
                      d="M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z"
                      fill="#373737"
                    ></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_1224_2961">
                      <rect width="24" height="24" fill="white"></rect>
                    </clipPath>
                  </defs>
                </svg>
              </v-btn>
            </template>

            <v-list>
              <v-list-tile v-for="(item, index) in crowdsources" :key="index" :href=item.href>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
        <div class="our-product-menu">
          <v-menu
            open-on-hover
            content-class="navbar-menu"
            attach="term-container"
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on">
                <span>About Us</span>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="select-down-arrow"
                >
                  <g clip-path="url(#clip0_1224_2961)">
                    <path
                      d="M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z"
                      fill="#373737"
                    ></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_1224_2961">
                      <rect width="24" height="24" fill="white"></rect>
                    </clipPath>
                  </defs>
                </svg>
              </v-btn>
            </template>

            <v-list>
              <v-list-tile v-for="(item, index) in about" :key="index" :href=item.href>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import image from '@/assets/img/cycleai_logo.png'
export default {
  data: () => ({
    image,
    open: false,
    products: [
      { title: 'Router Planner', href: 'https://cycleai.net/routeplanner/' },
      { title: 'Bikeable', href: 'https://cycleai.net/bikeable/'},
      { title: '360', href: 'https://cycleai.net/360/'},
    ],
    crowdsources: [
      { title: 'Hotspot Map', href: 'https://routeplanner.cycleai.net/#/hotspotMap' },
      { title: 'Perception poll', href: 'https://cycleai.net/perceptionPoll/'},
    ],
    about: [
      { title: 'Description', href: 'https://www.cycleai.net/aboutus/' },
      { title: 'Careers', href: 'https://www.cycleai.net/careers/' },
      { title: 'Contact', href: 'https://www.cycleai.net/#contact'},
    ]
  }),
  mounted() {
  },
  methods: {
    openMenu() {
      this.open = !this.open
    },
  }
}
</script>
  